<template>
  <div id="cart">
    <section class="cartMain">
      <div class="cartBox" v-for="(item, index) in list" :key="index">
        <div class="shop_info">
          <div class="all_check">
            <input type="checkbox" id="shop_a" class="shopChoice">
            <label for="shop_a" class="shop" :class="(item.check === 'true')?'mark':''" @click="shopchoose(item)"></label>
          </div>
          <div class="shop_name">
            {{item.shop_name}}
          </div>
        </div>
        <div class="order_content" v-if="item.products">
          <ul class="order_lists" v-for="(pro, goodsindex) in item.products" :key="goodsindex">
            <li class="list_chk">
              <input type="checkbox" id="checkbox_2" class="son_check">
              <label for="checkbox_2" :class="(pro.checked === 'false')?'':'mark'" @click="choose(item,pro, index, goodsindex)"></label>
            </li>
            <li class="list_con">
              <div class="list_img shop-info-img"><img :src="item.imgUrl ? (url + item.imgUrl) : defaultimg"></div>
            </li>
            <li class="list_info shop-info-text">
              <div class="list_text">
                <p>{{pro.text}}</p>
              </div>
              <div class="shop-price">
                <p class="price">￥{{parseInt(pro.price)}}</p>
                <div class="amount_box">
                  <a href="javascript:;" class="reduce reSty" @click="reduce(pro, goodsindex)">-</a>
                  <input type="text" v-model="pro.num" class="sum" readonly>
                  <a href="javascript:;" class="plus" @click="add(pro, index, goodsindex)">+</a>
                </div>
              </div>
            </li>
            <li class="list_op">
              <p class="delect" @click="handleDelectClick(pro, index, goodsindex)"><i class="iconfont">&#xe7fc;</i></p>
            </li>
            <div :class="(pro.state === 'true')?'statefalse':'statetrue'">
              <span>已下架</span>
              <p class="delect" @click="handleDelectClick(index, goodsindex)"><i class="iconfont">&#xe7fc;</i></p>
            </div>
          </ul>
        </div>
      </div>
      <!--底部-->
      <div class="bar-right payment-bar">
        <div class="list_chk all-select">
          <!--所有商品全选-->
          <input type="checkbox" id="all" class="whole_check">
          <label for="all" :class="fetchData.status?'mark':''" @click="cartchoose()"></label>
          <span>全选</span>
        </div>
        <div class="shop-total totalMoney">
          <span>总价：
            <span class="total total_text" id="AllTotal">{{this.fetchData.allsum}}.00</span>
          </span>
        </div>
        <div class="calBtn shopNum" @click="handleSettleClick">
          <span>{{state}}（</span>
          <span id="selectedTotal">{{this.fetchData.allnum}}</span>
          <span>）</span>
        </div>
      </div>
    </section>
    <section class="model_bg"></section>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'ShoppingList',
  props: {
    list: Array
  },
  data () {
    return {
      state: '结算',
      fetchData: {
        status: false, // 全选选中状态
        allchoose: 0, // 店铺选中个数
        allsum: 0, // 总计价格
        allnum: 0, // 总计数量
        postidlist: [], // 提交id数据
        postaidlist: [], // 取消选中商品时临时存放id数据
        postnumlist: [] // 提交数量数据
      },
      subscript: '', // 下标index
      subsubscript: '', // 小下标goodsindex
      pro: [], // 商品列表临时数组
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    choosetrue (item, pro, index, goodsindex) {
      pro.checked = 'true' // 将商品选中状态改为true
      // console.log(pro)
      // ++item.choose === item.products.length ? item.check = true : '' // 这里执行了两部，选中商品数量先+1，再与该店铺商品数量比较，如果相等就更改店铺选中状态为true
      ++item.choose
      if (item.choose === item.products.length) {
        item.check = 'true'
      } // 这里执行了两部，选中商品数量先+1，再与该店铺商品数量比较，如果相等就更改店铺选中状态为true
      // item.check ? ++this.fetchData.allchoose === this.list.length ? this.fetchData.status = true : this.fetchData.status = false : '' // 如果店铺选中状态改为true，选中店铺数量先+1，再与店铺数量比较，如果相等就更改全选选中状态为true
      if (item.check === 'true') {
        ++this.fetchData.allchoose
        if (this.fetchData.allchoose === this.list.length) {
          this.fetchData.status = true
        } else {
          this.fetchData.status = false
        }
      } // 如果店铺选中状态改为true，选中店铺数量先+1，再与店铺数量比较，如果相等就更改全选选中状态为true
      this.fetchData.allsum += parseInt(pro.sum) // 当触发商品选中按钮，将商品总价格添加到总计价格
      this.fetchData.allnum += parseInt(pro.num) // 当触发商品选中按钮，将商品总数量添加到总计数量
      this.fetchData.postidlist.push(pro.pro_id) // 将选中状态为true的商品id和数量插入到数组中
      this.fetchData.postnumlist.push(parseInt(pro.num)) // 将选中状态为true的商品id和数量插入到数组中
      console.log(this.fetchData.postidlist)
      console.log(this.fetchData.postnumlist)
    },
    choosefalse (item, pro, index, goodsindex) {
      pro.checked = 'false' // 将商品选中状态改为false
      // 提交选中商品的id和数量给后台
      this.fetchData.postaidlist.push(pro.pro_id)
      for (var i = 0; i < this.fetchData.postidlist.length; i++) {
        for (var j = 0; j < this.fetchData.postaidlist.length; j++) {
          var aid = this.fetchData.postidlist[i]
          var mid = this.fetchData.postaidlist[j]
          if (aid === mid) {
            this.fetchData.postidlist.splice(i, 1)
            this.fetchData.postnumlist.splice(i, 1)
            this.fetchData.postaidlist.splice(j, 1)
            console.log(this.fetchData.postidlist)
            console.log(this.fetchData.postnumlist)
          }
        } // 取消选中商品时遍历数组，查找数组中是否有id、数量与列表取消商品id、数量相等的数值，有则删除
      }
      --item.choose // 选中商品数量-1
      if (item.check === 'true') { // 如果店铺是被选中的，更改店铺选中状态
        item.check = 'false'
        --this.fetchData.allchoose // 并且选中店铺数量-1
      }
      this.fetchData.status = false // 无论之前全选的状态，将其改为false就行
      // console.log(parseInt(pro.sum))
      this.fetchData.allsum = this.fetchData.allsum - parseInt(pro.sum) // 当触发商品取消按钮，将商品总价格从总计价格删去
      // console.log(pro.num)
      this.fetchData.allnum = this.fetchData.allnum - parseInt(pro.num) // 当触发商品取消按钮，将商品总数量从总计数量删去
    },
    choose (item, pro, index, goodsindex) {
      !(pro.checked === 'true') ? this.choosetrue(item, pro, index, goodsindex) : this.choosefalse(item, pro, index, goodsindex)
    }, // 这里是绑定到html上的方法，取反是由于你在触发方法的时候取的是之前的状态
    shoptrue (item) {
      item.products.forEach((pro) => {
        // pro.checked === false ? this.choosetrue(item, pro) : ''
        if (pro.checked === 'false') {
          this.choosetrue(item, pro)
        } else {
          return ''
        }
      })
    }, // 循环店铺中的商品，先筛选出目前没选中的商品，给它执行choosetrue函数
    shopfalse (item) {
      item.products.forEach((pro) => {
        // pro.checked === true ? this.choosefalse(item, pro) : ''
        if (pro.checked === 'true') {
          this.choosefalse(item, pro)
        } else {
          return ''
        }
      })
    }, // 循环店铺中的商品，先筛选出目前被选中的商品，给它执行choosefalse函数
    shopchoose (item) {
      !(item.check === 'true') ? this.shoptrue(item) : this.shopfalse(item)
    },
    cartchoose () {
      // console.log(this.fetchData.status)
      this.fetchData.status = !this.fetchData.status // 取反改变状态
      this.fetchData.status ? (this.list.forEach((item) => this.shoptrue(item))) : (this.list.forEach((item) => this.shopfalse(item)))
    }, // 根据取反后的状态进行相应的店铺按钮操作
    /* 增加商品数量 */
    add (pro, index, goodsindex) {
      if (parseInt(pro.num) >= parseInt(pro.stock)) {
        this.handleAddTipClick()
      } else {
        this.pro = pro
        pro.num++ // 商品数量+1
        this.handleAddClick(pro)
        // console.log(parseInt(pro.num))
      }
    },
    handleAddClick (pro) {
      this.axios.post('/ApiCart/PostUpdateCartItem', {
        id: pro.pro_id,
        count: pro.num
      }).then(this.handleAddPostClick)
        .catch(this.handleAddFailClick)
    },
    // // 提交
    handleAddPostClick (res) {
      res = res.data
      if (res.okInfo === 'succeed') {
        if (this.pro.checked === 'true') {
          for (var i = 0; i < this.fetchData.postidlist.length; i++) {
            if (this.fetchData.postidlist[i] === this.pro.pro_id) {
              this.fetchData.postnumlist[i] = parseInt(this.pro.num)
              // console.log(this.fetchData.postnumlist)
              // console.log(pro.num)
            }
          }
        }
        // console.log(this.fetchData.postnumlist)
        this.pro.sum = parseInt(this.pro.sum) + parseInt(this.pro.price) // 商品总价变动
        // console.log(typeof (this.pro.sum))
        // pro.anum += pro.num // 商品数量变动
        // pro.checked ? this.fetchData.allsum += pro.price : this.fetchData.allsum // 这里判断下商品的状态决定是不是要改变总计价格
        // pro.checked ? this.fetchData.allnum += 1 : this.fetchData.allnum // 这里判断下商品的状态决定是不是要改变总计数量
        if (this.pro.checked === 'true') {
          this.fetchData.allsum += parseInt(this.pro.price)
        } else {
          return this.fetchData.allsum
        } // 这里判断下商品的状态决定是不是要改变总计价格
        if (this.pro.checked) {
          this.fetchData.allnum += 1
        } else {
          return this.fetchData.allnum
        } // 这里判断下商品的状态决定是不是要改变总计数量
      } else {
        alert(res.errorInfo)
      }
    },
    handleAddFailClick () {
      alert('添加失败')
    },
    reduce (pro, goodsindex) {
      if (parseInt(pro.num) === 1) {
        this.handleTipClick()
      } else {
        pro.num--
        this.handleReduceClick(pro)
      }
    },
    handleReduceClick (pro) {
      this.axios.post('/ApiCart/PostUpdateCartItem', {
        id: pro.pro_id,
        count: pro.num
      }).then(this.handleReducePostClick)
        .catch(this.handleReduceFailClick)
    },
    // // 提交
    handleReducePostClick (res) {
      res = res.data
      if (res.okInfo === 'succeed') {
        if (this.pro.checked === 'true') {
          for (var i = 0; i < this.fetchData.postidlist.length; i++) {
            if (this.fetchData.postidlist[i] === this.pro.pro_id) {
              this.fetchData.postnumlist[i] = parseInt(this.pro.num)
              console.log(this.fetchData.postnumlist)
              // console.log(pro.num)
            }
          }
        }
        this.pro.sum = parseInt(this.pro.sum) - parseInt(this.pro.price)
        // pro.anum -= pro.num
        // pro.checked ? (this.fetchData.allsum -= pro.price) : this.fetchData.allsum // 同上
        // pro.checked ? (this.fetchData.allnum -= 1) : this.fetchData.allnum // 同上
        if (this.pro.checked === 'true') {
          this.fetchData.allsum -= parseInt(this.pro.price)
          // console.log(this.fetchData.allsum)
        } else {
          return this.fetchData.allsum
        } // 同上
        if (this.pro.checked === 'true') {
          this.fetchData.allnum -= 1
        } else {
          return this.fetchData.allnum
        } // 同上
        this.pro = [] // 将pro数组清空
      } else {
        alert(res.errorInfo)
      }
    },
    handleReduceFailClick () {
      alert('减少商品数量失败')
    },
    // 删除商品提交数量和id
    handleDelectClick (pro, index, goodsindex) {
      this.subscript = index
      this.subsubscript = goodsindex
      this.axios.post('/ApiCart/PostUpdateCartItem', {
        id: pro.pro_id,
        count: 0
      }).then(this.handleDelectPostClick)
        .catch(this.handleDelectFailClick)
    },
    // 提交
    handleDelectPostClick (res) {
      res = res.data
      if (res.okInfo === 'succeed') {
        // console.log(this.list[this.subscript].products[this.subsubscript].price)
        var delectprice = this.list[this.subscript].products[this.subsubscript].price // 删除商品的单价
        var delectnum = this.list[this.subscript].products[this.subsubscript].num // 删除商品的数量
        var delectallsum = delectprice * delectnum // 删除商品的总价
        this.list[this.subscript].products.splice(this.subsubscript, 1) // 删除商品
        this.fetchData.allsum = this.fetchData.allsum - delectallsum // 总价减去删除商品的总价
        this.fetchData.allnum = this.fetchData.allnum - delectnum // 总数量减去删除商品的总数量
        this.subscript = ''
        this.subsubscript = '' // 将下标清空
      } else {
        alert(res.errorInfo)
      }
    },
    handleDelectFailClick (err) {
      alert(err)
    },
    handleTipClick () {
      alert('不可以再减少了哦~')
    },
    handleAddTipClick () {
      alert('不可以超过库存量哟')
    },
    /* 立即购买提交数据 */
    // 验证
    handleSettleClick (res) {
      alert('禁止操作')
      // console.log(this.fetchData.postidlist.length)
      // if (this.fetchData.postidlist.length !== 0) {
      //   this.buystate = '结算中...'
      //   this.$router.push({
      //     path: '/confirm',
      //     query: {
      //       Type: 'cart',
      //       cartids: [this.fetchData.postidlist]
      //     }
      //   })
      // } else {
      //   alert('请选择商品')
      // }
    }
  }
}
</script>

<style scoped>
html,body{ position: relative; width: 100%; min-height: 950px;}
input[type="checkbox"]{ display: none;}
label{ position: relative; display: inline-block; background: url("/static/img/icon_radio3.png") no-repeat 0 0; border-radius: 1px; width: 18px; height: 18px; background-size: 100%;}
label.mark{ background: url("/static/img/icon_radio4.png") no-repeat 0 0; background-size: 100%;}
.cartMain{ position: relative; margin: 0 auto; padding: 0px 0px 100px; min-height: 210px;}
/*购物车头部*/
.cartMain_hd{ width: 100%; height: 50px; line-height: 50px; color: #3c3c3c;}
.cartMain_hd .cartTop{ height: 50px;}
.cartMain_hd .cartTop .list_chk{ width: 80px; text-indent: 30px;}
.cartMain_hd .cartTop .list_con{ width: 312px;}
.cartMain_hd .cartTop .list_chk label{ position: absolute; left: 10px; top:19px; margin: 0;}
.cartMain_hd .cartTop .list_info{ padding: 0; text-indent: 15px;}
.cartMain_hd .cartTop .list_con{ text-indent: 140px;}
.cartBox{ width: 100%;}
.cartBox .shop_info{ position: relative; height: 38px; background-color: #fff; line-height: 38px; vertical-align: baseline; padding: 10px 15px; border-bottom: 1px solid #f6f6f6;}
.cartBox .shop_info .all_check{ position: relative; float: left; width: 30px; height: 38px;}
.cartBox .shop_info .all_check input[type="checkbox"]{ position: absolute; z-index: 0; left: -20px; top: -20px;}
.cartBox .shop_info .all_check .shop{ position: absolute; top:11px;}
.cartBox .shop_info .shop_name{ float: left; font-size: 14px;}
/*商品列表*/
.cartBox .order_content a{ display: block;}
.order_charge{ width: 100%; height: 40px; border-bottom: 1px solid #e7e7e7;}
.order_charge p{ display: inline-block; line-height: 40px;}
.order_charge p.charge_info{ margin:0 30px 0 50px;}
.order_charge p.charge_info span{ border: 1px solid #f60; padding:2px; color: #f60;}
.order_lists{ height: 87px; border-bottom: 5px solid #f8f8f8; padding: 10px 15px; display: flex; justify-content: space-between; position: relative;}
.order_lists .list_chk{ position: relative; width: 10%;}
.order_lists .list_con{ width: 23%;}
.order_lists .list_chk input[type="checkbox"]{ position: absolute; z-index: 0; left: -20px; top: -20px;}
.order_lists .list_chk label{ position: absolute; top: 42%; left: 0;}
.order_lists .list_con .list_img{ width: 80px; height: 80px; float: left;}
.order_lists .list_con .list_img img{ width: 100%; vertical-align: top;}
.order_lists .list_con .list_text{ margin: 20px 0 0 10px; line-height: 18px; width: 200px; float: left;}
.order_lists .list_con .list_text a{ color: #3c3c3c; margin-bottom: 5px;}
.order_lists .list_con .list_text a:hover{ color: #ff873e; text-decoration: underline;}
.order_lists .list_con .list_text .list_custom{ background-color:#ff8000; padding:3px; border-radius: 3px; color: #fff;}
.order_lists .list_info{ width: 60%; display: flex; flex-direction: column; justify-content: space-between;}
.order_lists .list_sum{ width: 10%;}
.order_lists .list_op{ width: 5%;}
.order_lists .list_info p{ color: #000; font-size: 14px; line-height: 18px; margin-left: 15px;}
.order_lists .list_info p:first-child{ word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
.order_lists .list_price{ width: 130px;}
.order_lists .list_price .price{ margin-top: 20px; line-height: 18px; color: #3c3c3c; font-weight: bold;}
.order_lists .list_price .charge{ position: relative; z-index: 4}
.order_lists .list_price .charge p{ color: #ff0000; border:1px solid #ff0000; width: 50px; height:15px; line-height: 15px; padding:3px;}
.order_lists .list_price .charge .chargebox{ display: none; width: 300px; height: 110px; background: #000; z-index: 1;}
.order_lists .list_amount{ width: 120px;}
.order_lists .list_amount .amount_box{ margin-top: 20px; width: 77px; height: 25px; position: relative;}
.order_lists .list_amount .amount_box input{ width: 39px; height: 15px; line-height: 15px; border: 1px solid #aaa; color: #343434; text-align: center; padding: 4px 0; background-color: #fff; z-index: 2; position: absolute; left: 18px; float: left;}
.order_lists .list_amount .amount_box a{ float: left; height: 23px; width: 17px; border: 1px solid #e5e5e5; background: #f0f0f0; text-align: center; line-height: 23px; color: #444; position: absolute; top:0;}
.order_lists .list_amount .amount_box a:hover{ border-color: #ff873e; text-decoration: none; color: #ff873e; z-index: 3;}
.order_lists .list_amount .amount_box .reduce{ left: 0;}
.order_lists .list_amount .amount_box .reSty{ color: #cbcbcb;}
.order_lists .list_amount .amount_box .reSty:hover{ border-right: none; border-color: #e5e5e5; text-decoration: none; color: #cbcbcb;}
.order_lists .list_amount .amount_box .plus{ border-left-color: transparent; right: 0;}
.order_lists .list_sum .sum_price{ line-height: 18px; margin-top: 20px; font-family: Verdana,Tahoma,arial; color: #900; font-weight: bold;}
.order_lists .list_op .collect{ margin-top: 20px;}
.order_lists .list_op .del{ line-height: 18px; margin:5px 0;}
.order_lists .list_op .custombox{ width: 200px; height: 350px; background-color: #000; display: none; position: relative; z-index: 9}
/*底部总计算价*/
.bar-right{ float: right; color: #3c3c3c;}
.bar-right strong{ color: #900;}
.bar-right .piece{ float: left; min-width: 110px; margin-right: 20px; height: 50px; line-height: 50px;}
.bar-right .piece .piece_num{ display: inline-block; padding: 0 10px; font-weight: 700; font-size: 18px;}
.bar-right .totalMoney{ float: left; min-width: 100px; height: 50px; line-height: 50px;}
.bar-right .calBtn{ float: left;}
.bar-right .calBtn a.btn_sty{ background: #ff873e; cursor: pointer;}
/*自己定义的模态框*/
.model_bg{ position: absolute; top:0; left: 0; bottom: 0; right: 0; background: rgba(0,0,0,.6); z-index: 999; display: none;}
.my_model{ position: fixed; display: none; top:50%; left: 50%; margin-top: -50px; margin-left: -200px; z-index: 9999; width: 360px; height: 120px; border: 1px solid #aeaeae; border-radius: 3px; padding: 20px; background: #fff;}
.my_model .title{ font-size: 14px; color: #3c3c3c; font-weight: 700; margin-bottom: 20px;}
.my_model .title .closeModel{ float: right;}
.my_model p{ line-height:16px;}
.my_model .opBtn{ margin-top: 20px;}
.my_model .opBtn a{ width: 58px; height: 28px; line-height: 28px; text-align: center; -webkit-border-radius: 1px; -moz-border-radius: 1px; -ms-border-radius: 1px; border-radius: 1px; display: inline-block; margin-right: 10px; font-weight: 700;}
.my_model .dialog-sure{ background: #52a0e5; color: #fff; border: 1px solid #52a0e5;}
.my_model .dialog-close{ background: #fff; border: 1px solid #d9d9d9; color: #3c3c3c;}
body{ background-color: #fff; font-family: '微软雅黑'; font-size: 14px; color: #000;}
a, a.link{color:#666;text-decoration:none;font-weight:500;}
h1,h2,h3,h4,h5,h6{font-weight: normal;}
.icon{ width: 30px; height: 30px;}
input[type="checkbox"]{ -webkit-appearance:none; outline: none; border: 0;}
.shop-group-item .item-first{ margin-top: 0;}
.shop-group-item li{ border-bottom: 5px solid #f8f8f8; margin-top: 5px;}
.list{ display: flex; padding: 10px 15px;}
.shop-info{ display: flex; align-items: center; width: 87%;}
.delect{ width: 13%;}
.delect p{ float: right;}
.shop-info .shop-info-img img{ margin-right: 7px; border-radius: 5px; width: 80px; height: 80px;}
.shop-info .shop-info-text h4{ font-size:14px; overflow: hidden;}
.order_lists .list_info .shop-brief{ height:25px; line-height:25px; font-size:12px; color:#81838e;}
.shop-info .shop-info-text .shop-brief span{ display:inline-block; margin-right:8px;}
.shop-price{ display: flex; justify-content: space-between;}
.order_lists .list_info .price { color:red; font-size:14px; }
.amount_box{ width:84px; border:1px solid #e0e0e0; color: #333; display: flex; justify-content: space-around;}
.reduce,.plus{ display:inline-block; width:23px; height:22px; line-height:22px; text-align:center; background:#fff; font-size:16px;}
.shop-info .shop-info-text .shop-arithmetic .failed{ color:#d1d1d1;}
.sum{ width:32px; text-align:center; border:none; display: inline-block; height:100%; margin:0 -6px;}
.shopPrice{ background:#fff; height:35px; line-height:35px; padding:0 15px; float: right;}
.shopNum{ background-color: #fff; height: 35px; line-height: 35px; padding: 0 15px;}
.shopNum a{ text-decoration: none; color: #fff;}
.shopPrice span{ color:#f00;}
.shop-pices span{ font-size: 12px;}
.shop-pices .price{ font-size: 14px;}
.all-checkbox .check-bottom{ width: 28%;}
.payment-bar{ display: flex; justify-content: space-between; align-items: center; width:100%; position:fixed; bottom:58px; border-top:1px solid #e0e0e0; background:#fff;}
.payment-bar .all-checkbox{ padding-left:20px; display: flex; width: 30%; align-items: center;}
.payment-bar .shop-total strong{ display:block; font-size:16px;}
.payment-bar .shop-total span{ font-size:14px; font-weight: bold;}
.payment-bar .shopNum { display:inline-block; width:85px; height:49px; line-height:49px; text-align:center; color:#fff; font-size:14px; background:#f23030;}
.shop-name{ display: flex; align-items: center; padding: 10px 15px; border-bottom: 1px solid #f6f6f6;}
.delect .iconfont{ font-size: 20px; color: #bdbdbd;}
.all-select{ margin-left: 15px; display: flex;}
.all-select span{ margin-left: 8px;}
.statefalse{ display: none;}
.statetrue{ display: block; position: absolute; background: rgba(204, 204, 204, 0.6); width: 100%; height: 100%; top: 0; bottom: 0; left: 0;}
.statetrue span{ position: absolute; left: 50%; margin-left: -30px; top: 41px; font-size: 20px;}
.statetrue .delect{ width: auto; float: right; margin: 10px 11px;}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/components/List.vue